import React from "react";
import RequiredServicesInfo from "./RequiredServicesInfo";

interface RequiredServicesProps {
  form: any;
  korbaAssitances: any;
}

const RequiredServices = ({ form, korbaAssitances }: RequiredServicesProps) => {
  return (
    <div style={{ padding: "2rem" }}>
      <RequiredServicesInfo form={form} korbaAssitances={korbaAssitances} />
    </div>
  );
};

export default RequiredServices;
